import React, { Suspense, lazy, useEffect } from "react";

const PracticalExamCalendar = lazy(() =>
   import("../../components/APanel/PracticalExamCalendar/PracticalExamCalendar"),
);

function APCalendarExamen() {
   useEffect(() => {
      document.title = "Instruire Auto | Interne";
   }, []);

   return (
      <main className="main" style={{ padding: 0 }}>
         <Suspense
            fallback={
               <div className="ultra-view__loading" role="status" aria-live="polite">
                  <div className="ultra-view__spinner" />
                  <span>Se încarcă calendarul intern...</span>
               </div>
            }
         >
            <PracticalExamCalendar />
         </Suspense>
      </main>
   );
}

export default APCalendarExamen;
